import type { IOauthRepository } from '../IOauthRepository';
import type { OAuthProvider, OAuthSignInDto } from '../oauth.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';
import 'reflect-metadata';
import type { User } from '@repositories/userRepository/user.types';

@injectable()
export class OauthRepository implements IOauthRepository {
  /**
   * 새로운 통합 OAuth 로그인 메서드
   * 백엔드 요구사항: 유동적 provider, 추가 파라미터 지원
   * JSON 형태로 데이터 전송
   */
  async oauthSignIn(provider: OAuthProvider, rqData: OAuthSignInDto, tenantId?: string): Promise<User> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    // 동적 SSO 프로바이더 사용 시 tenantId 헤더 추가
    if (tenantId) {
      headers['X-TenantID'] = tenantId;
    }

    // JSON 형태로 데이터 전송
    const requestData = {
      authCode: rqData.authCode,
    };

    const result = await API.post<User>(`/api/v1/actions/${provider}/sign-in/redirect`, requestData, { headers });

    return result.data;
  }
}
